import Vue from "vue";
import Vuex from "vuex";

//import views
import subscription from "./views/subscription.js";
import checkout from "./views/checkout.js";
import order from "./views/order.js";
import misc from "./views/misc.js";
import error from "./views/error.js";
import search from "./views/search";

Vue.use(Vuex);

let views = [misc, checkout, order, subscription, error, search];

let state = {};
let mutations = {};
let getters = {};
let actions = {};
let modules = {};

for (let i = 0; i < views.length; i++) {
  state = { ...state, ...views[i].state };
  mutations = { ...mutations, ...views[i].mutations };
  getters = { ...getters, ...views[i].getters };
  actions = { ...actions, ...views[i].actions };
  modules = { ...modules, ...views[i].modules };
}

export default new Vuex.Store({
  strict: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  modules: modules,
});
